import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { voorgerenderdVoor, vergeetVoorgerenderd } from '../utils/voorgerenderd';

// Terugval voor <Suspense>: op de eerste, voorgerenderde pagina blijft de HTML
// van react-snap staan tot de code van de pagina geladen is, in plaats van het
// laadscherm (`children`). Zo knippert de pagina niet en blijft de scrollpositie
// (bijv. bij een #anker) staan. Daarna en op andere pagina's: het laadscherm.
function VoorgerenderdeFallback({ children }) {
  const { pathname } = useLocation();
  const html = voorgerenderdVoor(pathname);

  // De terugval verdwijnt zodra de pagina zelf er is; dan is de kopie niet meer nodig.
  useEffect(() => () => vergeetVoorgerenderd(), []);

  if (!html) return children;
  // Eigen HTML van deze site (react-snap), dezelfde die de server al stuurde.
  return <div style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default VoorgerenderdeFallback;
